import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/images/logo.jpg";
import Logowhite from "../../assets/images/corteva-logo-white.jpg";
import scanIcon from "../../assets/images/scanIcon.png";
import { logPageView } from "../../utils/analytics";
import { useSelector } from "react-redux";
import { decryptJSON } from "../service/Encrtyption";
import { isOtpVerified } from "../../utils/otpSession";
import { parseScanData } from "../../utils/parseScanData";
import ReactGA from 'react-ga4';

const LANGUAGE_LABELS = {
  hi: "हि",
  mr: "म",
  en: "En",
  te: "తె",
  kn: "ಕ",
  ta: "த",
  or: "ଓ",
  bn: "ব",
  gu: "ગુ",
  pa: "ਪ",
  ma: "മ",
};

const Header = ({ isHide = false, navbarWhite, hideHomeIcon = false }) => {
  const location = useLocation();
  const { lang } = useParams();
  const navigate = useNavigate();
  const [surl, setsurl] = useState('');
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const scandataUrl = useSelector((state) => state?.scandataUrl);
  const parsedScan = parseScanData(scandataUrl);
  const isScanOtpVerified =
    parsedScan?.otpVerified === true ||
    parsedScan?.otpVerified === "true" ||
    parsedScan?.otpVerified === 1;

  useEffect(() => {
    const scanedData = sessionStorage.getItem('k');
    if (scanedData) {
      const surlderypted = decryptJSON(scanedData).replace(/"/g, '');
      setsurl(surlderypted);
    }
  }, []);


  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageChange = (language) => {

    ReactGA.event({
      category: "Btn",
      label: "Language Change Btn",
      action: ` ${language} Language Changed`,
    });


    i18n.changeLanguage(language);
    const currentPath = location.pathname.replace(`/${lang}`, '');
    const searchParams = location.search;
    console.log(searchParams + "searchParams");
    const newPath = `/${language}${currentPath}${searchParams}`;
    navigate(newPath);
    setIsOpen(false);
  };

  // const handleLanguageChange = (language) => {
  //   // debugger;
  //   i18n.changeLanguage(language);
  //   const currentPath = location.pathname.replace(`/${lang}`, '');
  //   if (user) {
  //     navigate(`/${language}${currentPath}`);
  //   } else {
  //     navigate(`/${language}${currentPath}?${decodeURIComponent(surl)}`);
  //   }
  //   setIsOpen(false);
  // };

  const handleNavigation = () => {
    if (user) {
      navigate(`/${lang}/giftHistory`);
    } else {
      const currentPath = `/login`;
      navigate(`/${lang}${currentPath}?${decodeURIComponent(surl)}`);
    }
  };

  const handleHomeClick = () => {
    if (user && (isOtpVerified() || isScanOtpVerified)) { 
      ReactGA.event({
        category: "Btn",
        action: "Gift History Button Clicked",
        label: "Gift History Button",
      });  
      navigate(`/${lang}/giftHistory`);
      return;
    }
    handleNavigation();
  };

  const showHomeButton = !hideHomeIcon && Boolean(user) && (isOtpVerified() || isScanOtpVerified);
  // const showHomeButton = false;


  return (
    <div className="container-fluid p-0 fixed-header">
      <nav className={`${navbarWhite ? 'bg-white' : ""} navbar bg-white px-2 shadow`}>
        <span className="navbar-brand">
          <img
            src={navbarWhite ? Logowhite : Logowhite}
            alt="Logo"
            width="150" height="75" style={{ height: 'auto' }} fetchpriority="high"
          />
        </span>

        {!isHide && (
          <div className="form-inline my-2 my-lg-0 ml-auto align-items-center">
            {showHomeButton && (
              <button
                type="button"
                className="headerHomeBtn btn btn-link p-0 mr-3"
                onClick={handleHomeClick}
                aria-label={t("home")}
                title={t("home")}
                style={{ fontSize: '1.5rem', lineHeight: 1 }}
              >
                {/* <i className="fa fa-home" aria-hidden="true" /> */}
                <img src={scanIcon} alt="scanIcon" className="img-fluid" />
              </button>
            )}
            <div className="dropdown text-center language-switcher" onClick={toggleDropdown}>
              <div className="language-switcher__label">
                <span>{LANGUAGE_LABELS[lang] || LANGUAGE_LABELS.hi}</span>
                <i className="fa fa-chevron-down language-switcher__chevron" aria-hidden="true" />
              </div>
              <p className="mb-0 text-xsm">{t('ChangeLanguage')}</p>

              {isOpen && (
                <div className="dropdown-menu header_dropdown">

                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange("hi")}
                  >
                    हिन्दी
                  </button>

                  {/* <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("en")}
                    >
                      English
                    </button> */}

                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange("te")}
                  >
                    తెలుగు
                  </button>


                  {/* <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("kn")}
                    >
                      ಕನ್ನಡ
                    </button> */}


                  {/* <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("ta")}
                    >
                      தமிழ்
                    </button> */}


                  {/* <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("or")}
                    >
                      ଓଡିଆ
                    </button> */}

                  {/* <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("bn")}
                    >
                      বাংলা
                    </button>  */}

                  <button
                    className="dropdown-item"
                    onClick={() => handleLanguageChange("mr")}
                  >
                    मराठी
                  </button>


                  {/*   <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("gu")}
                    >
                      ગુજરાતી
                    </button>


                   <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("pa")}
                    >
                      ਪੰਜਾਬੀ
                    </button>

                  

                    {/* <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("en")}
                    >
                      English
                    </button> */}





                  {/* <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange("ma")}
                    >
                      മലയാളം
                    </button>  */}

                </div>
              )}
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Header;
